/** @jsx jsx **/
import { Box, Flex, jsx } from 'theme-ui'
import { FC } from 'react'
import { Close } from '~/components/icons/close'
import { space } from '~/gatsby-plugin-theme-ui'

type Props = {
  onClick: (value: string) => void
  value: string
}

const FilterBadge: FC<Props> = ({ value, onClick }) => {
  return (
    <Flex
      sx={{
        bg: 'bg',
        border: '1px solid',
        borderColor: 'border',
        borderRadius: '20px',
        height: 40,
        whiteSpace: 'nowrap',
        alignItems: 'center',
        mb: [space.gridGap2],
        mr: [space.gridGap2],
      }}
    >
      <Box
        as="span"
        sx={{
          color: 'muted',
          variant: 'buttons.noStyle',
          px: [space.gridGap2],
        }}
      >
        {value.name}
      </Box>
      {/* <button
      onClick={() => {
        onClick( value)}}
      type="button"
      sx={{
        variant: 'buttons.noStyle',
        px: [space.gridGap2],
        height: '100%',
        svg: {
          fill: 'muted',
        },
      }}
    >
      <Close />
    </button> */}
    </Flex>
  )
}

export default FilterBadge
